
'use strict';
var angular:angular.IAngularStatic =  require('angular');
import {Injectable, Inject} from 'ng-metadata/core';
import appConfigModule from '../appConfig/appConfig.module';
import {PrimoResponse} from '../infra/dataStructures/PrimoResponses/autocompleteInterface';

@Injectable()
export class AutoComplete {



    constructor(@Inject('autoCompleteConfig') private autoCompleteConfig : AutoCompleteConfig,
                @Inject('$http') private $http : ng.IHttpService) {




    }
    isAutocompleteEnabledFor(scope) {
        return this.autoCompleteConfig.isEnabled(scope);
    }

    search(queryTerm, scope) {
        let userParams = {
            q:queryTerm
        };
        let params = angular.extend({}, this.autoCompleteConfig.getDefaultParams(scope), userParams);
        return this.$http.jsonp(this.autoCompleteConfig.url,
            {
                jsonpCallbackParam: 'json.wrf',
                params: params
            })
            .then(function(data:{data:{response: PrimoResponse.IAutocompleteSuggestions}}) {
                return data.data.response.docs.map(function(e) {
                    return e.text;
                })});

    }

}
export default [ appConfigModule.name ];




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/autocomplete.service.ts